import { Link } from "react-router-dom";

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.path
        ? `https://mogu.com${item.path}`
        : undefined,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400" />
            )}
            {item.path ? (
              <Link
                to={item.path}
                className="hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.name}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}